import Resource from './Resource';

export default class LogoutOtherDevices extends Resource{
	constructor( options = {} ){
		let {
			baseUrl = '',
			query = {}
		} = options;

		let config = {
			baseUrl: baseUrl,
			route: "security/logout-other-devices",
			version: "",
			query: query
		};

		super(config);
		return this;
	}

	get(){
		return this.request();
	}
}
